import pickController from "./pick.controller";

export default [
    "$parse",
    ($parse) => {
        return {
            restrict: "EA",
            transclude: true,
            replace: true,
            require: ["appPick", "ngModel"],
            controller: pickController,
            controllerAs: "pick",
            template: `<div class="ws-pick" ng-transclude></div>`,
            link: ($scope, $element, $attr, ctrls) => {
                const pickCtrl = ctrls[0];
                const ngModel = ctrls[1];

                let originalData = [];
                let ngModalValue = [];
                let originData = [];
                let targetData = [];

                let model = analysis($attr.ngOptions);

                pickCtrl.setModel(model);

                pickCtrl.setNgModel(ngModel);

                $scope.$watch(model.data, (newVal) => {
                    originalData = newVal || [];
                    flush();
                });

                ngModel.$formatters.unshift(function (modalValue) {
                    ngModalValue = modalValue || [];
                    flush();
                    return modalValue;
                });

                pickCtrl.registerFlush(flush);

                function flush(modelValue?: any[]) {
                    if (modelValue) {
                        ngModalValue = modelValue;
                    }
                    originData = originalData.filter((item) => {
                        return (
                            ngModalValue.find((iitem) => {
                                return objectEqual(iitem, model.value({ [model.model]: item }));
                            }) === undefined
                        );
                    });
                    targetData = originalData.filter((item) => {
                        return (
                            ngModalValue.find((iitem) => {
                                return objectEqual(iitem, model.value({ [model.model]: item }));
                            }) !== undefined
                        );
                    });
                    pickCtrl.changeOrigin(pickCtrl.convert(originData));
                    pickCtrl.changeTarget(pickCtrl.convert(targetData));
                }

                function analysis(optionsString) {
                    let model;
                    if (optionsString && optionsString.includes("for ") && optionsString.includes("in ")) {
                        model = {};
                        let inIndex = optionsString.lastIndexOf("in ");
                        let forIndex = optionsString.indexOf("for ");
                        model.data = optionsString.slice(inIndex + 2).trim();
                        model.model = optionsString.slice(forIndex + 3, inIndex).trim();
                        let asIndex = optionsString.indexOf("as ");
                        if (asIndex === -1) {
                            model.valueStr = optionsString.slice(0, forIndex).trim();
                            model.viewStr = optionsString.slice(0, forIndex).trim();
                            model.value = $parse(model.valueStr);
                            model.view = $parse(model.viewStr);
                        } else {
                            model.valueStr = optionsString.slice(0, asIndex).trim();
                            model.viewStr = optionsString.slice(asIndex + 2, forIndex).trim();
                            model.value = $parse(model.valueStr);
                            model.view = $parse(model.viewStr);
                        }
                    }
                    return model;
                }

                function objectEqual(o1, o2) {
                    if (typeof o1 !== typeof o2) return false;
                    if (angular.isArray(o1) || angular.isObject(o1)) {
                        return angular.equals(JSON.parse(angular.toJson(o1)), JSON.parse(angular.toJson(o2)));
                    } else {
                        return o1 === o2;
                    }
                }
            }
        };
    }
];
